
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1axkx_kq4eh_141",
  "item": "awsui_item_1axkx_kq4eh_179",
  "disable-item-paddings": "awsui_disable-item-paddings_1axkx_kq4eh_182",
  "disable-paddings": "awsui_disable-paddings_1axkx_kq4eh_185",
  "sortable-item": "awsui_sortable-item_1axkx_kq4eh_192"
};
  